import { render } from "./gabon-footer.vue?vue&type=template&id=5d1e8782&scoped=true"
import script from "./gabon-footer.vue?vue&type=script&lang=js"
export * from "./gabon-footer.vue?vue&type=script&lang=js"

import "./gabon-footer.vue?vue&type=style&index=0&id=5d1e8782&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1e8782"]])

export default __exports__